import { render, staticRenderFns } from "./BundleShareDropdown.vue?vue&type=template&id=04dd11fe&"
import script from "./BundleShareDropdown.vue?vue&type=script&lang=js&"
export * from "./BundleShareDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports